import React, { useEffect, useRef } from 'react';
import css from './SearchFilter.module.css';

interface SearchFilterProps {
  filterText: string;
  setFilterText: (text: string) => void;
  currentPath: string;
}

const SearchFilter: React.FC<SearchFilterProps> = ({ filterText, setFilterText, currentPath }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  
  useEffect(() => {
    setFilterText('');
  }, [currentPath, setFilterText]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Allow users to type forward slashes normally in the search
    setFilterText(e.target.value);
  };

  return (
    <div className={css.searchContainer}>
      <div className={css.inputWrapper}>
        <input
          ref={inputRef}
          type="text"
          placeholder="Filter files and folders..."
          value={filterText}
          onChange={handleFilterChange}
          className={css.searchInput}
        />
        {filterText && (
          <button 
            className={css.clearSearch} 
            onClick={() => {
              setFilterText('');
              inputRef.current?.focus();
            }}
            title="Clear filter"
            type="button"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchFilter;